import { marked } from "marked";

/**
 * Strips markdown formatting from text and returns plain text
 * Converts markdown to HTML, then extracts text content using DOM parser
 * @param markdown - The markdown text to strip
 * @returns Plain text without markdown formatting
 */
export const stripMarkdown = (markdown: string): string => {
  if (!markdown) return "";

  try {
    // Convert markdown to HTML using marked
    const html = marked.parse(markdown) as string;

    // Create a temporary div element to parse the HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    // Extract text content (automatically strips all HTML tags)
    const plainText = tempDiv.textContent || tempDiv.innerText || "";

    // Clean up extra whitespace and return
    return plainText.replace(/\s+/g, " ").trim();
  } catch (error) {
    console.error("Error stripping markdown:", error);
    // Fallback: return original text with basic cleanup if parsing fails
    return markdown.replace(/\s+/g, " ").trim();
  }
};

/**
 * Converts markdown text to HTML
 * @param markdown - The markdown text to convert
 * @returns HTML string
 */
export const convertMarkdownToHtml = (markdown: string): string => {
  if (!markdown) return "";
  try {
    return marked.parse(markdown) as string;
  } catch (error) {
    console.error("Error converting markdown to HTML:", error);
    return markdown;
  }
};
